/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Rectangle } from "./modelRectangle";

class ControllerRectangle extends ControllerModel {
  constructor() {
    super("ControllerRectangle");
    
    this.setNewNode = (callback, location) => {
      let rectangle = new Rectangle(location);
      rectangle.decorate(callback);
      this.addNode(rectangle)
      SingletonFlowchart.SaveStatus();
    }

    this.loadNode = (node, callback) => {
      let rectangle = new Rectangle();
      rectangle.copyFrom(node);
      rectangle.decorate(callback);
      this.addNode(rectangle);
    }

    this.getProperties = async (node) => {
      let n = new Rectangle();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new Rectangle();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerRectangle };
